(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbb-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const range = root.querySelector('[data-compare-range]');
      range?.addEventListener('input', () => root.style.setProperty('--dbb-position', `${range.value}%`));
    };
    const all = (s) => {
      if (s.matches?.('[data-dbb-compare]')) init(s);
      s.querySelectorAll?.('[data-dbb-compare]').forEach(init);
    };
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbb-customer-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-video-track]'),
        cards = [...root.querySelectorAll('[data-video-card]')],
        dots = root.querySelector('[data-video-dots]');
      if (!track || !cards.length) return;
      let index = 0;
      const perView = () => (innerWidth < 750 ? 1 : 3);
      const pages = () => Math.max(1, cards.length - perView() + 1);
      for (let i = 0; i < pages(); i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.ariaLabel = `Show videos ${i + 1}`;
        d.addEventListener('click', () => go(i));
        dots.appendChild(d);
      }
      const go = (i) => {
        index = Math.max(0, Math.min(pages() - 1, i));
        track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
        [...dots.children].forEach((d, n) => d.classList.toggle('is-active', n === index));
      };
      cards.forEach((card) => {
        const video = card.querySelector('video'),
          playButton = card.querySelector('[data-card-play]'),
          playIcon = playButton?.querySelector('i'),
          soundButton = card.querySelector('[data-card-sound]'),
          soundIcon = soundButton?.querySelector('i');
        let controlsTimer;
        const showControls = (hideAfter = 0) => {
          clearTimeout(controlsTimer);
          card.classList.remove('is-controls-hidden');
          if (hideAfter && video && !video.paused) {
            controlsTimer = setTimeout(() => {
              if (!video.paused) card.classList.add('is-controls-hidden');
            }, hideAfter);
          }
        };
        const setPlaybackState = (playing) => {
          card.classList.toggle('is-playing', playing);
          playButton?.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          playIcon?.classList.toggle('fa-play', !playing);
          playIcon?.classList.toggle('fa-pause', playing);
          if (playing) {
            showControls(2000);
          } else {
            clearTimeout(controlsTimer);
            card.classList.remove('is-controls-hidden');
          }
        };
        const setSoundState = () => {
          if (!video) return;
          soundButton?.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          soundIcon?.classList.toggle('fa-volume-xmark', video.muted);
          soundIcon?.classList.toggle('fa-volume-high', !video.muted);
        };
        playButton?.addEventListener('click', () => {
          cards.forEach((other) => {
            if (other !== card) {
              other.querySelector('video')?.pause();
            }
          });
          if (video) {
            if (video.paused) {
              video.muted = false;
              setSoundState();
              video.play().catch(() => setPlaybackState(false));
            } else {
              video.pause();
            }
          }
        });
        soundButton?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          setSoundState();
          if (!video.paused) showControls(5000);
        });
        video?.addEventListener('click', () => {
          if (!video.paused) video.pause();
        });
        card.addEventListener('mouseenter', () => {
          if (video && !video.paused) showControls(5000);
        });
        card.addEventListener('touchstart', () => {
          if (video && !video.paused) showControls(5000);
        }, { passive: true });
        video?.addEventListener('play', () => setPlaybackState(true));
        video?.addEventListener('pause', () => setPlaybackState(false));
        video?.addEventListener('ended', () => setPlaybackState(false));
        setPlaybackState(video ? !video.paused : false);
        setSoundState();
      });
      root.querySelector('[data-video-prev]')?.addEventListener('click', () => go(index - 1));
      root.querySelector('[data-video-next]')?.addEventListener('click', () => go(index + 1));
      go(0);
    };
    const all = (s) => {
      if (s.matches?.('[data-dbb-customer-videos]')) init(s);
      s.querySelectorAll?.('[data-dbb-customer-videos]').forEach(init);
    };
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbb-instagram-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const modal = root.querySelector('[data-story-modal]');
      const viewer = root.querySelector('[data-story-viewer]');
      const slides = [...root.querySelectorAll('[data-story-slide]')];
      const progressButtons = [...root.querySelectorAll('[data-story-item-jump]')];
      const progressBars = [...root.querySelectorAll('[data-story-progress]')];
      const username = root.querySelector('[data-story-user]');
      const userAvatar = root.querySelector('[data-story-user-avatar]');
      const pauseButton = root.querySelector('[data-story-pause]');
      const pauseIcon = pauseButton?.querySelector('i');
      const soundButton = root.querySelector('[data-story-sound]');
      const soundIcon = soundButton?.querySelector('i');
      const imageDuration = Number(root.dataset.imageDuration) || 5000;
      const shouldLoop = root.dataset.loopStories === 'true';
      if (!modal || !viewer || !slides.length) return;
      let activeProfile = 0;
      let activeItem = 0;
      let muted = true;
      let imagePaused = false;
      let imageElapsed = 0;
      let lastFrame = 0;
      let imageFrame;
      let trigger;
      let pointerStartX = 0;

      const currentSlide = () => slides[activeProfile];
      const currentItems = () => [...currentSlide().querySelectorAll('[data-story-item]')];
      const currentItem = () => currentItems()[activeItem];
      const currentVideo = () => currentItem()?.querySelector('video');
      const stopImageTimer = () => {
        cancelAnimationFrame(imageFrame);
        imageFrame = undefined;
        lastFrame = 0;
      };
      const setProgress = (percent) => {
        const itemCount = currentItems().length;
        progressButtons.forEach((button, index) => {
          button.hidden = index >= itemCount;
        });
        progressBars.forEach((bar, index) => {
          let width = 0;
          if (index < activeItem) width = 100;
          if (index === activeItem) width = Math.max(0, Math.min(100, percent));
          bar.style.width = `${width}%`;
        });
      };
      const setPauseState = (paused) => {
        pauseButton?.setAttribute('aria-label', paused ? 'Play story' : 'Pause story');
        pauseIcon?.classList.toggle('fa-play', paused);
        pauseIcon?.classList.toggle('fa-pause', !paused);
      };
      const setSoundState = () => {
        soundButton?.setAttribute('aria-label', muted ? 'Unmute story' : 'Mute story');
        soundIcon?.classList.toggle('fa-volume-xmark', muted);
        soundIcon?.classList.toggle('fa-volume-high', !muted);
      };
      const setImage = (image, url) => {
        if (!image) return;
        image.classList.toggle('has-image', Boolean(url));
        if (url) image.src = url;
        else image.removeAttribute('src');
      };
      const updatePreview = (preview, index) => {
        if (!preview) return;
        const slide = slides[(index + slides.length) % slides.length];
        preview.hidden = slides.length < 2;
        setImage(preview.querySelector('[data-preview-poster]'), slide.dataset.poster || '');
        setImage(preview.querySelector('[data-preview-avatar]'), slide.dataset.avatar || '');
        preview.querySelector('[data-preview-name]').textContent = slide.dataset.username || '';
      };
      const runImageTimer = (timestamp) => {
        if (!lastFrame) lastFrame = timestamp;
        if (!imagePaused) imageElapsed += timestamp - lastFrame;
        lastFrame = timestamp;
        setProgress((imageElapsed / imageDuration) * 100);
        if (imageElapsed >= imageDuration) {
          advanceItem(1);
          return;
        }
        imageFrame = requestAnimationFrame(runImageTimer);
      };
      const renderItem = (index) => {
        stopImageTimer();
        const items = currentItems();
        activeItem = Math.max(0, Math.min(items.length - 1, index));
        slides.forEach((slide) => {
          slide.querySelectorAll('video').forEach((video) => {
            video.pause();
            if (!slide.classList.contains('is-active') || !video.closest('[data-story-item]')?.classList.contains('is-active')) video.currentTime = 0;
          });
        });
        items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeItem));
        items.forEach((item, itemIndex) => {
          if (itemIndex !== activeItem) {
            const video = item.querySelector('video');
            if (video) video.currentTime = 0;
          }
        });
        imageElapsed = 0;
        imagePaused = false;
        setProgress(0);
        const video = currentVideo();
        if (video) {
          video.muted = muted;
          video.currentTime = 0;
          video.play().then(() => setPauseState(false)).catch(() => setPauseState(true));
        } else {
          setPauseState(false);
          imageFrame = requestAnimationFrame(runImageTimer);
        }
      };
      const renderProfile = (index, itemIndex = 0) => {
        stopImageTimer();
        activeProfile = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeProfile;
          slide.classList.toggle('is-active', isActive);
          if (!isActive) {
            slide.querySelectorAll('[data-story-item]').forEach((item) => item.classList.remove('is-active'));
            slide.querySelectorAll('video').forEach((video) => {
              video.pause();
              video.currentTime = 0;
            });
          }
        });
        const slide = currentSlide();
        username.textContent = slide.dataset.username || '';
        setImage(userAvatar, slide.dataset.avatar || '');
        updatePreview(root.querySelector('.dbb-stories__preview--prev'), activeProfile - 1);
        updatePreview(root.querySelector('.dbb-stories__preview--next'), activeProfile + 1);
        renderItem(itemIndex);
      };
      const advanceItem = (direction) => {
        const items = currentItems();
        const nextItem = activeItem + direction;
        if (nextItem >= 0 && nextItem < items.length) {
          renderItem(nextItem);
          return;
        }
        const nextProfile = activeProfile + direction;
        if (nextProfile >= slides.length && !shouldLoop) {
          close();
          return;
        }
        if (nextProfile < 0 && !shouldLoop) {
          renderProfile(0, 0);
          return;
        }
        const wrappedProfile = (nextProfile + slides.length) % slides.length;
        const targetItems = slides[wrappedProfile].querySelectorAll('[data-story-item]');
        renderProfile(wrappedProfile, direction < 0 ? targetItems.length - 1 : 0);
      };
      const open = (index) => {
        trigger = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        renderProfile(index, 0);
        viewer.focus();
      };
      const close = () => {
        stopImageTimer();
        slides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()));
        modal.hidden = true;
        document.body.style.overflow = '';
        trigger?.focus?.();
      };
      const togglePause = () => {
        const video = currentVideo();
        if (video) {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        } else {
          imagePaused = !imagePaused;
          setPauseState(imagePaused);
        }
      };

      root
        .querySelectorAll('[data-story-open]')
        .forEach((button) => button.addEventListener('click', () => open(Number(button.dataset.storyOpen))));
      root.querySelectorAll('[data-story-close]').forEach((button) => button.addEventListener('click', close));
      root
        .querySelectorAll('[data-story-prev]')
        .forEach((button) => button.addEventListener('click', () => advanceItem(-1)));
      root
        .querySelectorAll('[data-story-next]')
        .forEach((button) => button.addEventListener('click', () => advanceItem(1)));
      root
        .querySelectorAll('[data-story-item-jump]')
        .forEach((button) => button.addEventListener('click', () => renderItem(Number(button.dataset.storyItemJump))));
      root.querySelector('[data-story-toggle]')?.addEventListener('click', togglePause);
      pauseButton?.addEventListener('click', togglePause);
      soundButton?.addEventListener('click', () => {
        muted = !muted;
        const video = currentVideo();
        if (video) video.muted = muted;
        setSoundState();
      });
      slides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          const item = video.closest('[data-story-item]');
          video.addEventListener('timeupdate', () => {
            if (slide.classList.contains('is-active') && item?.classList.contains('is-active') && video.duration) {
              setProgress((video.currentTime / video.duration) * 100);
            }
          });
          video.addEventListener('play', () => {
            if (item?.classList.contains('is-active')) setPauseState(false);
          });
          video.addEventListener('pause', () => {
            if (slide.classList.contains('is-active') && item?.classList.contains('is-active') && video.currentTime < video.duration) setPauseState(true);
          });
          video.addEventListener('ended', () => {
            if (slide.classList.contains('is-active') && item?.classList.contains('is-active')) advanceItem(1);
          });
        });
      });
      viewer.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
      });
      viewer.addEventListener('pointerup', (event) => {
        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 55) advanceItem(distance > 0 ? -1 : 1);
      });
      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowLeft') advanceItem(-1);
        if (event.key === 'ArrowRight') advanceItem(1);
        if (event.key === ' ' || event.key === 'k') {
          event.preventDefault();
          togglePause();
        }
      });
      setSoundState();
    };
    const load = (scope) => {
      if (scope.matches?.('[data-dbb-stories]')) init(scope);
      scope.querySelectorAll?.('[data-dbb-stories]').forEach(init);
    };
    load(document);
    document.addEventListener('shopify:section:load', (event) => load(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbb-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents, format) => {
      const value = (cents / 100).toFixed(2);
      return format
        .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
    };
    const init = (root) => {
      if (!root || root.dataset.dbbReady) return;
      root.dataset.dbbReady = 'true';
      const slides = [...root.querySelectorAll('[data-media-index]')],
        thumbs = [...root.querySelectorAll('[data-thumb-index]')],
        thumbRail = root.querySelector('[data-dbb-thumbs]');
      let active = slides.findIndex((x) => x.classList.contains('is-active'));
      if (active < 0) active = 0;
      const show = (index) => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((s, i) => {
          s.classList.toggle('is-active', i === active);
          s.querySelectorAll('video').forEach((v) => {
            if (i !== active) v.pause();
          });
        });
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === active));
        if (thumbRail && thumbs[active])
          thumbRail.scrollTo({
            left: thumbs[active].offsetLeft - (thumbRail.clientWidth - thumbs[active].offsetWidth) / 2,
            behavior: 'smooth',
          });
      };
      thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.thumbIndex))));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(active - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
      root
        .querySelector('[data-thumbs-prev]')
        ?.addEventListener('click', () =>
          thumbRail?.scrollBy({ left: -thumbRail.clientWidth * 0.8, behavior: 'smooth' })
        );
      root
        .querySelector('[data-thumbs-next]')
        ?.addEventListener('click', () =>
          thumbRail?.scrollBy({ left: thumbRail.clientWidth * 0.8, behavior: 'smooth' })
        );
      const qty = root.querySelector('input[name="quantity"]');
      root
        .querySelector('[data-qty-minus]')
        ?.addEventListener('click', () => (qty.value = Math.max(1, Number(qty.value || 1) - 1)));
      root.querySelector('[data-qty-plus]')?.addEventListener('click', () => (qty.value = Number(qty.value || 1) + 1));
      const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]'),
        groups = [...root.querySelectorAll('[data-option-index]')],
        variantInput = root.querySelector('[data-variant-id]'),
        price = root.querySelector('[data-current-price]'),
        compare = root.querySelector('[data-compare-price]'),
        save = root.querySelector('[data-save-badge]'),
        button = root.querySelector('[data-add-button]'),
        buttonText = root.querySelector('[data-add-text]'),
        moneyFormat = root.dataset.moneyFormat,
        addText = root.dataset.addLabel,
        soldText = root.dataset.soldLabel;
      const updateVariant = () => {
        const selected = groups.map((g) => g.querySelector('.is-selected')?.dataset.optionValue),
          variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = money(variant.price, moneyFormat);
        if (variant.compare_at_price > variant.price) {
          compare.textContent = money(variant.compare_at_price, moneyFormat);
          compare.classList.remove('is-hidden');
          save.textContent = `SAVE ${Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          )}%`;
          save.classList.remove('is-hidden');
        } else {
          compare.classList.add('is-hidden');
          save.classList.add('is-hidden');
        }
        button.disabled = !variant.available;
        buttonText.textContent = variant.available ? addText : soldText;
        if (variant.featured_media) {
          const i = slides.findIndex((s) => Number(s.dataset.mediaId) === variant.featured_media.id);
          if (i >= 0) show(i);
        }
        window.history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      };
      groups.forEach((g) =>
        g.querySelectorAll('[data-option-value]').forEach((p) =>
          p.addEventListener('click', () => {
            g.querySelectorAll('[data-option-value]').forEach((x) => x.classList.remove('is-selected'));
            p.classList.add('is-selected');
            g.querySelector('[data-option-label]').textContent = p.dataset.optionValue;
            updateVariant();
          })
        )
      );
    };
    const all = (scope) => {
      if (scope.matches?.('[data-dbb-product]')) init(scope);
      scope.querySelectorAll?.('[data-dbb-product]').forEach(init);
    };
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbb-video-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-spotlight-track]'),
        slides = [...root.querySelectorAll('[data-spotlight-slide]')];
      if (!track || !slides.length) return;
      let active = Math.min(slides.length - 1, Math.max(0, Number(root.dataset.start) || 0));
      const stop = (slide) => {
        const v = slide.querySelector('video');
        slide.classList.remove('is-engaged');
        if (v) {
          v.pause();
          v.muted = true;
        }
      };
      const position = () => {
        const slide = slides[active],
          viewport = root.querySelector('.dbb-spotlight__viewport');
        track.style.transform = `translate3d(${
          viewport.clientWidth / 2 - slide.offsetLeft - slide.offsetWidth / 2
        }px,0,0)`;
      };
      const activate = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const distance = Math.abs(i - active);
          slide.classList.toggle('is-active', i === active);
          slide.classList.toggle('is-far', distance > 1);
          if (i !== active) stop(slide);
        });
        position();
        const video = slides[active].querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
      };
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video'),
          play = slide.querySelector('[data-spotlight-play]'),
          sound = slide.querySelector('[data-sound-toggle]'),
          pause = slide.querySelector('[data-pause-toggle]'),
          progress = slide.querySelector('[data-progress]');
        play?.addEventListener('click', () => {
          activate(i);
          if (video) {
            slide.classList.add('is-engaged');
            video.muted = false;
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        });
        sound?.addEventListener('click', () => {
          if (video) video.muted = !video.muted;
        });
        pause?.addEventListener('click', () => {
          if (!video) return;
          if (video.paused) {
            video.play();
            pause.textContent = 'Ⅱ';
          } else {
            video.pause();
            pause.textContent = '▶';
          }
        });
        video?.addEventListener('timeupdate', () => {
          if (progress && video.duration) progress.style.width = `${(video.currentTime / video.duration) * 100}%`;
        });
        slide.addEventListener('click', (e) => {
          if (!e.target.closest('button') && i !== active) activate(i);
        });
      });
      root.querySelector('[data-spotlight-prev]')?.addEventListener('click', () => activate(active - 1));
      root.querySelector('[data-spotlight-next]')?.addEventListener('click', () => activate(active + 1));
      new ResizeObserver(position).observe(root);
      activate(active);
    };
    const all = (scope) => {
      if (scope.matches?.('[data-dbb-spotlight]')) init(scope);
      scope.querySelectorAll?.('[data-dbb-spotlight]').forEach(init);
    };
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hv-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-hv-logo-marquee]';

    const initialise = (section) => {
      if (!section || section.dataset.hvLogoReady === 'true') return;

      const track = section.querySelector('.hv-logo-bar__track');
      const source = section.querySelector('[data-hv-logo-source]');
      if (!track || !source || !source.children.length) return;

      section.dataset.hvLogoReady = 'true';
      let frame;

      const buildLoop = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          track.classList.remove('is-ready');
          track.querySelectorAll('[data-hv-logo-clone]').forEach((clone) => clone.remove());

          const groupWidth = source.getBoundingClientRect().width;
          const viewportWidth = section.getBoundingClientRect().width;
          if (groupWidth <= 0 || viewportWidth <= 0) return;

          const groupCount = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1);

          for (let index = 1; index < groupCount; index += 1) {
            const clone = source.cloneNode(true);
            clone.removeAttribute('data-hv-logo-source');
            clone.setAttribute('data-hv-logo-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone
              .querySelectorAll('[data-shopify-editor-block]')
              .forEach((item) => item.removeAttribute('data-shopify-editor-block'));
            clone
              .querySelectorAll('a, button, input, select, textarea, [tabindex]')
              .forEach((item) => item.setAttribute('tabindex', '-1'));
            track.appendChild(clone);
          }

          track.style.setProperty('--hv-loop-distance', `${groupWidth}px`);
          void track.offsetWidth;
          track.classList.add('is-ready');
        });
      };

      const resizeObserver = new ResizeObserver(buildLoop);
      resizeObserver.observe(section);

      source.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', buildLoop, { once: true });
      });

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildLoop);
      buildLoop();

      section.hvLogoDestroy = () => {
        cancelAnimationFrame(frame);
        resizeObserver.disconnect();
        delete section.dataset.hvLogoReady;
      };
    };

    const initialiseAll = (root = document) => {
      if (root.matches && root.matches(selector)) initialise(root);
      root.querySelectorAll(selector).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      if (section && section.hvLogoDestroy) section.hvLogoDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
